module.exports = __webpack_public_path__ + "img/d-step3.72316523.png";